<div class="ui-kit-tag-list" data-qa-block="tag-list" *ngIf="documentTypes">
  <div
    *ngFor="let type of documentTypes | uniqueDocumentTypes; trackBy: documentTypesTrackBy"
    class="ui-kit-tag"
    data-qa="tag-name"
    tabindex="0"
    [class.tag__selected]="selectedDocumentTypes.has(type.attachment)"
    [attr.data-qa-tag]="type.attachment"
    (click)="setSelectedDocumentTypes(type.shortName)"
  >
    {{ type.shortName }}
  </div>
</div>
